import { render, staticRenderFns } from "./BaseReuseTable.vue?vue&type=template&id=74205216"
import script from "./BaseReuseTable.vue?vue&type=script&lang=js"
export * from "./BaseReuseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports